import { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { CopyToClipboard } from "react-copy-to-clipboard";
import dayjs from "dayjs";
import { useWindowSize } from "../../utils/useWindowSize";

import { Box, Stack, Typography, CardMedia, IconButton, Grid, Divider, TextField } from "@mui/material";

// Components
import { userState, reportInfoType, reportIdentifierType } from "../../interface/MainInterface";
import { HttpUnAuthApi } from "../../interface/unauth-api";
import KeywordReport from "./component/KeywordReport";
import ReportSkeleton from "./component/ReportSkeleton";
import KeywordCategoryChart from "./chart/KeywordCategoryChart";
import MonthltyKeywordChart from "./chart/MonthltyKeywordChart";
import PopChartDetail from "./component/PopChartDetail";
import Toast from "../../utils/Toast";

// CSS
import "./Report.css";
import KeywordReportSummary from "./component/KeywordReportSummary";

interface propsType {
  userState: userState;
}

const unAuthAPI = new HttpUnAuthApi();

const Report = (props: propsType) => {
  const { sk } = useParams();
  const toastRef: any = useRef();
  const popChartDeatilRef: any = useRef();
  const reportTitleRef: any = useRef();
  const windowSize = useWindowSize();

  const [reportIdentifier, setReportIdentifier] = useState<reportIdentifierType | null>();
  const [reportInfo, setReportInfo] = useState<reportInfoType[] | null>();
  const [expandAll, setExpandAll] = useState(false);

  const [keywordList, setKeywordList] = useState<any>([]);

  const [keywordChartData, setKeywordChartData] = useState<any>(null);
  const [monthlyKeywordChartData, setMonthlyKeywordChartData] = useState<any>(null);

  const [editTitle, setEditTitle] = useState(false);
  const [reportTitle, setReportTitle] = useState<any>("");

  useEffect(() => {
    get_report_list();
    get_pending_report();
    get_keyword_list();
    return () => {
      setReportIdentifier(null);
      setReportInfo(null);
      setExpandAll(false);
      setKeywordList([]);
      setKeywordChartData(null);
      setMonthlyKeywordChartData(null);
      setEditTitle(false);
      setReportTitle("");
    };
  }, []);

  const get_report_list = async () => {
    const param: any = {
      command: "get_report_list",
      pk: "report_info",
      sk: sk,
    };

    const res = await unAuthAPI.post(param);
    if (res.code === "200") {
      setReportInfo(res.response.report_list);
    }
  };

  const get_pending_report = async () => {
    const param: any = {
      command: "get_pending_report",
      pk: "report_info",
      sk: sk,
    };

    const res = await unAuthAPI.post(param);
    if (res.code === "200") {
      setReportIdentifier(res.response.report_info);
    }
  }

  useEffect(() => {
    if (reportIdentifier) {
      setReportTitle(reportIdentifier?.report_title);

      const labels: any = [];
      for (const item of reportIdentifier.scrap_info.scrap_key_list) {
        const keywords = Array.isArray(item.keyword) ? item.keyword : [];
        for (const word of keywords) {
          if (!labels.includes(word)) {
            labels.push(word);
          }
        }
      }

      const countByPk: any = {};
      for (const item of reportIdentifier.scrap_info.scrap_key_list) {
        const { show_pk } = item;

        const keywords = Array.isArray(item.keyword) ? item.keyword : [];
        if (!countByPk[show_pk]) {
          countByPk[show_pk] = new Array(labels.length).fill(0);
        }

        for (const key of keywords) {
          const index = labels.indexOf(key);
          if (index !== -1) {
            countByPk[show_pk][index]++;
          }
        }
      }

      const datasets = Object.keys(countByPk).map((show_pk) => ({
        label: show_pk,
        data: countByPk[show_pk],
        maxBarThickness: 23,
      }));
      
      const chartData = {
        axis: "y",
        labels: labels,
        datasets: datasets,
      };

      setKeywordChartData(chartData);
    }
  }, [reportIdentifier]);

  const get_keyword_list = async () => {
    const param: any = {
      command: "get_keyword_list",
      gubun: "keyword_count",
      category: "all",
    };

    // 검색 조건별 날짜 세팅
    // 3일전
    const from_dtm = dayjs().subtract(3, "month").startOf("month").format("YYYYMMDD");
    const to_dtm = dayjs().add(1, "day").format("YYYYMMDD");
    param.from_dtm = from_dtm;
    param.to_dtm = to_dtm;

    const res = await unAuthAPI.post(param);
    if (res.code === "200") {
      setKeywordList(res.response.keyword_list);
    } else {
      console.error("[ERROR] get_keyword_list : ", res.response.error_msg);
    }
  };

  //키워드별 카테고리 분포 차트 데이터 만들기
  useEffect(() => {
    // if (reportInfo) {
    //   setReportTitle(reportIdentifier?.report_title);

    //   let keywords: any = [];
    //   let categories: any = [];
    //   for (const data of reportInfo) {
    //     keywords.push(data.scrap_keyword);
    //     for (const detail of data.scrap_list) {
    //       if (categories.indexOf(detail.pk) < 0) {
    //         categories.push(detail.pk);
    //       }
    //     }
    //   }

    //   // dataset 만들기
    //   let datasets: any = [];
    //   for (const cate of categories) {
    //     let data: any = [];
    //     for (const repo of reportInfo) {
    //       let cateCnt = 0;
    //       for (const detail of repo.scrap_list) {
    //         if (cate === detail.pk) cateCnt += 1;
    //       }
    //       data.push(cateCnt);
    //     }
    //     datasets.push({
    //       label: cate,
    //       data: data,
    //       maxBarThickness: 23,
    //     });
    //   }

    //   const chartData = {
    //     axis: "y",
    //     labels: keywords,
    //     datasets: datasets,
    //   };

    //   console.log("chartData : ", chartData);
    //   setKeywordChartData(chartData);
    // }
  }, [reportInfo]);

  useEffect(() => {
    if (keywordList.length > 0 && reportIdentifier) {

      const briefKeywords: any = [];
      for (const item of reportIdentifier.scrap_info.scrap_key_list) {
        const keywords = Array.isArray(item.keyword) ? item.keyword : [];
        for (const word of keywords) {
          if (!briefKeywords.includes(word)) {
            briefKeywords.push(word);
          }
        }
      }

      let months: any = [];
      for (const keywordInfo of keywordList) {
        const month = dayjs(keywordInfo.sk).format("MM");
        if (months.indexOf(month) < 0) {
          months.push(month);
        }
      }

      months = months.sort();

      const labels = [...months.map((data: string, index: number) => parseInt(data) + "월")];
      // dataset 만들기
      let datasets: any = [];
      for (const keyword of briefKeywords) {
        let data: any = [];
        for (const month of months) {
          let keyCnt = 0;
          for (const keywordInfo of keywordList) {
            const _month = dayjs(keywordInfo.sk).format("MM");
            if (keyword === keywordInfo.pk.split("#")[1] && month === _month) {
              keyCnt = keyCnt + keywordInfo.count;
            }
          }
          data.push(keyCnt);
        }
        datasets.push({
          label: keyword,
          data: data,
        });
      }

      const chartData = {
        labels: labels,
        datasets: datasets,
      };
      setMonthlyKeywordChartData(chartData);
    }

  }, [keywordList, reportIdentifier]);

  useEffect(() => {
    // if (keywordList.length > 0 && reportInfo) {
    //   const repoKeywords: any = [];
    //   for (const repo of reportInfo) {
    //     repoKeywords.push(repo.scrap_keyword);
    //   }

    //   let months: any = [];
    //   for (const keywordInfo of keywordList) {
    //     const month = dayjs(keywordInfo.sk).format("MM");
    //     if (months.indexOf(month) < 0) {
    //       months.push(month);
    //     }
    //   }

    //   months = months.sort();

    //   const labels = [...months.map((data: string, index: number) => parseInt(data) + "월")];
    //   // dataset 만들기
    //   let datasets: any = [];
    //   for (const keyword of repoKeywords) {
    //     let data: any = [];
    //     for (const month of months) {
    //       let keyCnt = 0;
    //       for (const keywordInfo of keywordList) {
    //         const _month = dayjs(keywordInfo.sk).format("MM");
    //         if (keyword === keywordInfo.pk && month === _month) {
    //           keyCnt = keyCnt + keywordInfo.count;
    //         }
    //       }
    //       data.push(keyCnt);
    //     }
    //     datasets.push({
    //       label: keyword,
    //       data: data,
    //     });
    //   }

    //   const chartData = {
    //     labels: labels,
    //     datasets: datasets,
    //   };

    //   console.log("chartData ", chartData);
    //   setMonthlyKeywordChartData(chartData);
    // }
  }, [keywordList, reportInfo]);

  const openChartDetail = (flag: string) => {
    if (flag === "keyword") {
      popChartDeatilRef.current.open(flag, keywordChartData);
    } else {
      popChartDeatilRef.current.open(flag, monthlyKeywordChartData);
    }
  };

  const update_report_title = async () => {
    if (!reportIdentifier) return;
    if (reportIdentifier?.report_title === reportTitle) {
      setEditTitle(false);
      return;
    }

    const param: any = {
      command: "update_report_title",
      sk: reportIdentifier.sk,
      new_title: reportTitle,
      user_id: props.userState.id,
    };

    const res = await unAuthAPI.post(param);
    if (res.code === "200") {
      const temp: any = reportInfo;
      const tempIdentifier: any = reportIdentifier;
      reportIdentifier.report_title = reportTitle;
      setReportInfo(temp);
      setReportIdentifier(tempIdentifier);
    }
    setEditTitle(false);
  };

  const getMonthAndWeek = () => {
    const today = new Date();
    const month = today.getMonth() + 1;
    const weekNumber = Math.ceil((today.getDate() + new Date(today.getFullYear(), today.getMonth(), 1).getDay()) / 7);
    return `${month}월 ${weekNumber}주차 키워드`
  }

  const handlePrint = () => {
    window.print();
  }

  return (
    <>
      {reportInfo ? (
        <section id="commWrap" className="report-list">
          {/* <PdfGenerator filename="test.pdf" buttonLabel="PDF 다운로드"> */}
          {/* <PrintArea> */}
          <div className="print-area">
          <article className="article-01">
            <div className="article-tit ta-l break-all">
              <div className="report-info" >
                {!editTitle ? (
                  <Typography
                    sx={{
                      maxWidth: "calc(100% - 1px)",
                      overflow: "hidden",
                      whiteSpace: "nowrap",
                      textOverflow: "ellipsis",
                      fontSize: windowSize.width > 1023 ? "2.5rem" : "2rem",
                      fontWeight: "800",
                      lineHeight: "1.3",
                      cursor: "text",
                    }}
                    onClick={(e) => {
                      if (reportIdentifier?.user_id === props.userState.id) {
                        e.stopPropagation(); // 부모창 클릭이벤트 전달 방지
                        setEditTitle(true);
                      }
                    }}
                  >
                    {reportIdentifier?.report_title}
                  </Typography>
                ) : (
                  <TextField
                    inputRef={reportTitleRef}
                    className="scrap-title"
                    value={reportTitle}
                    autoFocus
                    sx={{
                      width: `${Math.max(100, reportTitle && reportTitle.length * 35)}px`,
                    }}
                    onChange={(e) => {
                      setReportTitle(e.target.value);
                    }}
                    onClick={(e) => {
                      e.stopPropagation(); // 부모창 클릭이벤트 전달 방지
                    }}
                    onKeyUp={(e) => {
                      if (e.key === "Enter") {
                        e.preventDefault();
                        reportTitleRef.current.blur();
                      }
                    }}
                    onBlur={(e) => {
                      e.preventDefault();
                      update_report_title();
                    }}
                    inputProps={{
                      style: {
                        fontSize: windowSize.width > 1023 ? "2.5rem" : "2rem",
                        fontWeight: "800",
                        lineHeight: "1.3",
                        padding: 0,
                        textAlign: "left",
                      },
                      enterKeyHint: "Enter",
                    }}
                  ></TextField>
                )}
                <button
                  className="btn-print"
                  onClick={handlePrint}
                >
                  <i>
                    <img src="/images/icon-print.png" alt="" />
                  </i>
                  <span>인쇄하기</span>
                </button>
              </div>
              <div className="fake-height" />
              <Stack direction={"row"} sx={{ alignSelf : 'flex-end' }} gap={1}>
                  <Typography sx={{ fontWeight: '500' }}>{getMonthAndWeek()}:</Typography>
                  <Typography sx={{ fontWeight: '700' }}>
                    {reportIdentifier?.report_keyword.join(", ")}
                  </Typography>
                </Stack>
            </div>
            {reportInfo?.map((data: any, index: number) => (
                <KeywordReport
                  key={`keyword-report-${index}`}
                  info={data}
                />
              ))}

            <Box>
              <Grid container spacing={5}>
                <Grid item xs={12} md={12} lg={6}>
                  <Stack direction={"column"} spacing={0}>
                    <Divider sx={{ borderColor: "#2a2a2a" }}/>
                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", p: "9px 0px" }}>
                      <Typography sx={{ fontSize: "20px", fontWeight: "700" }}>{"키워드별 카테고리 분포"}</Typography>
                      <IconButton
                        sx={{ p: 0 }}
                        onClick={() => {
                          openChartDetail("keyword");
                        }}
                      >
                        <CardMedia component={"img"} image="/images/btn-kw-flow.png"></CardMedia>
                      </IconButton>
                    </Box>
                    {keywordChartData && (
                      <Box sx={{ height: "285px" }}>
                        <KeywordCategoryChart chartData={keywordChartData} />
                      </Box>
                    )}
                  </Stack>
                </Grid>
                <Grid item xs={12} md={12} lg={6}>
                  <Stack direction={"column"} spacing={0}>
                    <Divider sx={{ borderColor: "#2a2a2a" }}/>
                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", p: "9px 0px" }}>
                      <Typography sx={{ fontSize: "20px", fontWeight: "700" }}>{"월별 키워드 언급량 추이"}</Typography>
                      <IconButton
                        sx={{ p: 0 }}
                        onClick={() => {
                          openChartDetail("monthly");
                        }}
                      >
                        <CardMedia component={"img"} image="/images/btn-kw-flow.png"></CardMedia>
                      </IconButton>
                    </Box>
                    {monthlyKeywordChartData && (
                      <Box sx={{ height: "285px" }}>
                        <MonthltyKeywordChart chartData={monthlyKeywordChartData} />
                      </Box>
                    )}
                  </Stack>
                </Grid>
              </Grid>
            </Box>
          </article>
          </div>
          {/* </PrintArea> */}
          {/* </PdfGenerator> */}
          
          {/* <Box sx={{ height: "30px" }}></Box> */}
          
          <div>
            <CopyToClipboard
              text={`${process.env.REACT_APP_MAIN_DOMAIN}/report/${sk}`}
              onCopy={() => {
                toastRef.current?.toast("URL을 복사했습니다.", "success", 4000, {
                  vertical: "top",
                  horizontal: "center",
                });
              }}
            >
              <Box sx={{ display: "flex", justifyContent: "center", p: 1, mt: "80px", mb: "40px" }} className="url-copy">
                <button>
                  <i>
                    <span>URL 복사</span>
                  </i>
                  <img src="/images/icon-link.png" alt="" />
                </button>
              </Box>
            </CopyToClipboard>
          </div>
        </section>
      ) : (
        <ReportSkeleton />
      )}
      <PopChartDetail ref={popChartDeatilRef} callback={() => {}} />
      <Toast ref={toastRef} />
    </>
  );
};

export default Report;
